// extracted by mini-css-extract-plugin
export default {"benchmarksLink":"benchmarksLink__s__pj","tag":"tag__Gwi53","seeMore":"seeMore__JKFpT"};